import React, { useState, useEffect } from 'react';
import { Input } from '@chapche/ui';
import { SearchIcon } from '../appearence/icons/search_icon';
import { CloseIcon } from '../appearence/icons/close_icon';

const SearchInput = ({ placeholder, itemsStorageService }) => {
    const [searchValue, setSearchValue] = useState('');

    const changeSearchInput = (e) => {
        setSearchValue(e.target.value);
        itemsStorageService.setSearchString(e.target.value);
    };

    const changeInputValue = () => {
        setSearchValue(itemsStorageService.getSearchString());
    };

    useEffect(() => {
        itemsStorageService.registerFiltersChangingObserver(changeInputValue);
        return () => itemsStorageService.unRegisterFiltersChangingObserver(changeInputValue);
    }, []);

    return (
        <label className="product__label product__search-label relative m-0 block w-full">
            <SearchIcon nameOfClass="product__input-icon pointer-events-none absolute top-1/2 left-16 h-20 w-20 -translate-y-1/2" />
            <Input
                fullWidth
                className="pl-40 pr-40"
                placeholder={placeholder}
                value={searchValue}
                onChange={changeSearchInput}
            />
            {searchValue ? (
                <span
                    className="absolute top-1/2 right-16 -translate-y-1/2 cursor-pointer"
                    onClick={() => changeSearchInput({ target: { value: '' } })}
                >
                    <CloseIcon nameOfClass="product__input-icon_search h-16 w-16" />
                </span>
            ) : null}
        </label>
    );
};

export default SearchInput;
